module.exports = __webpack_public_path__ + "img/03.96622303.jpg";